import { getSelectedCollection } from "../home_ui/selectors";

const isFetchingSuggestions = (state, collection, featured) => {
  let loading_suggestions = featured ? state.circle_suggestions.loading_featured : state.circle_suggestions.loading_all;

  if (loading_suggestions[collection] === true) {
    return true;
  } else {
    return false;
  }
};
const shouldFetchCircleSuggestions = (state, collection, offset, featured) => {
  if (isFetchingSuggestions(state, collection, featured)) {
    return false;
  }
  let next_offset = featured ? state.circle_suggestions.next_featured_offset : state.circle_suggestions.next_all_offset;

  if (offset < next_offset[collection]) {
    return false;
  }
  return true;
};

const shouldFetchSuggestion = (state, collection, featured, id) => {
  const suggestions = getCircleSuggestions(state, featured);
  const suggestions_from_collection = suggestions[collection] ? suggestions[collection] : [];
  const found_suggestions = suggestions_from_collection.filter((suggestion) => suggestion.id === id);
  return !(found_suggestions.length === 1);
};

const getCircleSuggestions = (state, featured) => {
  const suggestions = featured ? state.circle_suggestions.featured : state.circle_suggestions.all;
  return suggestions ? suggestions : {};
};
const getCircleSuggestionsForSelectedCollection = (state, featured) => {
  const suggestions = getCircleSuggestions(state, featured)[getSelectedCollection(state)];
  return suggestions ? suggestions : [];
};

const getLoadingMarkers = (state, featured) => {
  return featured ? state.circle_suggestions.loading_featured : state.circle_suggestions.loading_all;
};

const loadingInitialSuggestionsForSelectedCollection = (state, featured) => {
  return (
    !getCircleSuggestionsForSelectedCollection(state, featured).length &&
    getLoadingMarkers(state, featured)[getSelectedCollection(state)]
  );
};

const loadingMoreSuggestionsForSelectedCollection = (state, featured) => {
  return (
    getCircleSuggestionsForSelectedCollection(state, featured).length &&
    getLoadingMarkers(state, featured)[getSelectedCollection(state)]
  );
};

const hasMoreInSelectedCollection = (state, featured) => {
  return featured
    ? state.circle_suggestions.has_more_featured[getSelectedCollection(state)]
    : state.circle_suggestions.has_more_all[getSelectedCollection(state)];
};
const getNextOffsetInCollection = (state, featured) => {
  return featured
    ? state.circle_suggestions.next_featured_offset[getSelectedCollection(state)]
    : state.circle_suggestions.next_all_offset[getSelectedCollection(state)];
};

const getSuggestionWithId = (state, id, featured) => {
  const suggestions = getCircleSuggestionsForSelectedCollection(state, featured);
  const circle = suggestions.filter((suggestion) => suggestion.id === id);
  return circle.length ? circle[0] : undefined;
};

export {
  isFetchingSuggestions,
  shouldFetchCircleSuggestions,
  getCircleSuggestions,
  getCircleSuggestionsForSelectedCollection,
  loadingInitialSuggestionsForSelectedCollection,
  getLoadingMarkers,
  loadingMoreSuggestionsForSelectedCollection,
  hasMoreInSelectedCollection,
  getNextOffsetInCollection,
  getSuggestionWithId,
  shouldFetchSuggestion,
};
